<template>
  <div class="user">
    <div class="user-msg-box">
      <div class="common-flex user-msg common-justify-between">
        <div class="common-flex common-align-center">
          <img
            v-if="userMsg.headImg"
            class="header"
            :src="userMsg.headImg"
            alt=""
          />
          <img
            v-else
            class="header"
            src="../../assets/images/defaultHeader.png"
            alt=""
          />
          <div>
            <div class="name">{{ userMsg.username }}</div>
            <div class="type">
              <span class="iconfont iconzhanghao"></span>
              {{ userMsg.parentId == 0 ? $t("mainAccount") : $t("subAccount") }}
              <!-- Main account number -->
            </div>
          </div>
        </div>
        <div class="user-date common-flex common-align-center">
          <div
            v-for="(item, index) in userDate"
            :key="index"
            class="common-hover"
            @click="userData(item, index)"
            :style="[
              index < userDate.length - 1
                ? { borderRight: '1px solid #E6E8EB' }
                : {},
            ]"
          >
            <div class="num">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
        <div class="log-out common-hover" @click="logOut">
          {{ $t("user.logOut") }}
        </div>
      </div>
    </div>
    <div class="recharge">
      <img class="bg-img" src="../../assets/images/userbg.png" />
      <div class="balance">
        {{ userMsg.accountBalance }}
        <!-- <div class="recharge-title common-hover" @click="rechargeClick">
          {{ $t("user.recharge") }}
        </div> -->
      </div>
      <div class="account-balance">{{ $t("user.accountBalance") }}</div>
      <div class="account-tips">{{ $t("user.tips") }}</div>
    </div>
    <div class="user-function common-flex common-justify-between">
      <div
        @click="userClick(item, index)"
        class="
          common-hover common-flex common-direction-column common-justify-center
        "
        v-for="(item, index) in $t('user.userFunction')"
        :key="index"
      >
        <div class="title">
          {{ item.title }}
          <Icon type="ios-arrow-forward" />
        </div>
        <div class="content">{{ item.content }}</div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <Modal footer-hide v-model="changePasswordShow" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("password.changePassword") }}</div>
        <div class="individual-account">
          {{ $t("password.individualAccount") }}
        </div>
        <div class="input-box common-flex">
          <div>{{ $t("password.originalPassword") }}</div>
          <input
            v-model="changePassword.oldPassword"
            :placeholder="$t('password.oneUser')"
            type="password"
          />
        </div>
        <div class="input-box common-flex">
          <div>{{ $t("password.newPassword") }}</div>
          <input
            v-model="changePassword.newPassword"
            :placeholder="$t('password.newPasswordTips')"
            type="password"
          />
        </div>
        <div class="input-box common-flex" style="margin-bottom: 60px">
          <div>{{ $t("password.enterAgain") }}</div>
          <input
            v-model="changePassword.againPassword"
            :placeholder="$t('password.newPasswordTips')"
            type="password"
          />
        </div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="backPassword">
            {{ $t("password.back") }}
          </div>
          <div class="submit common-hover" @click="submitPassword">
            {{ $t("password.submit") }}
          </div>
        </div>
      </div>
    </Modal>
    <!-- 充值 -->
    <!-- <Modal footer-hide v-model="rechargeShow" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("recharge.name") }}</div>
        <div class="individual-account">
          {{ $t("recharge.subtitle") }}
        </div>
        <div class="input-box common-flex" style="margin-bottom: 17px">
          <div>{{ $t("recharge.rechargeAmount") }}</div>
          <input :placeholder="$t('recharge.rechargeAmount')" type="text" />
        </div>
        <div class="common-flex" style="margin-bottom: 181px">
          <div class="current-balance">
            {{ $t("recharge.currentBalance") }}：
          </div>
          <div class="current-price">$0.00</div>
        </div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="backRecharge">
            {{ $t("password.back") }}
          </div>
          <div class="submit common-hover">{{ $t("password.submit") }}</div>
        </div>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {setMenu} from '../../libs/util';
export default {
  name: "user",
  data() {
    return {
      changePassword: {
        // originalPassword: "",
        // password: "",
        oldPassword: "",
        newPassword: "",
        againPassword: "",
      },
      // 账户
      userMsg: "",
      //   忘记密码弹框
      changePasswordShow: false,
      // 充值弹框
      rechargeShow: false,
      userDate: [
        {
          label: this.$t("user.client"),
          num: 1,
          id: 0,
        },
        {
          label: this.$t("user.subAccount"),
          num: 1,
          id: 1,
        },
        {
          label: this.$t("user.orders"),
          num: 1,
          id: 2,
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "loginoutAction", //登出
      "getAccountInfoAction", //获得个人信息
      "changePasswordByOriginalPasswordAction", //修改密码
    ]),
    // 修改密码
    submitPassword() {
      let pass = true;
      let that = this
      for (let key in this.changePassword) {
        if (this.changePassword[key] == "") {
          this.$Message.error(this.$t("user.passwordTip." + key));
          pass = false;
          break;
        }
      }
      if (pass) {
        if (
          this.changePassword.newPassword === this.changePassword.againPassword
        ) {
          let params = {
            originalPassword: "",
            password: "",
          };
          params.originalPassword = this.changePassword.oldPassword
          params.password = this.changePassword.newPassword
          this.changePasswordByOriginalPasswordAction(params).then(res=>{
            if(res.code==0){
              this.changePasswordShow = false
              this.$Message.success(res.message)
              setTimeout(function(){
                that.logoutAction()

              },500)
            }
          })
        } else {
          this.$Message.error(this.$t("user.passwordTip.atypism"));
        }
      }
    },
    // 获得个人信息
    getAccountInfo() {
      this.getAccountInfoAction().then((res) => {
        console.log("res", res);
        this.userDate[0].num = res.data.customerNum;
        this.userDate[1].num = res.data.subAccountNum;
        this.userDate[2].num = res.data.orderNum;
        this.userMsg = res.data;
      });
    },
    // 跳转不同用户数据
    userData(e, index) {
      if (e.id == 0) {
        this.$router.push("./customerList");
      } else if (e.id == 1) {
        this.$router.push("./subAccount");
      } else if (e.id == 2) {
        this.$router.push("/underProduction");
      }
    },
    // 退出登录
    logOut() {
      let that = this
      this.$Modal.confirm({
        title: this.$t("user.context"),
        content: '',
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          that.loginoutAction()
        },
      });
    },

    // 隐藏重置密码
    backPassword() {
      this.changePasswordShow = false;
    },
    // 显示充值
    rechargeClick() {
      this.rechargeShow = true;
    },
    // 隐藏充值
    backRecharge() {
      this.rechargeShow = false;
    },
    // 用户下方按钮
    userClick(e, index) {
      // 0跳转地址  1客户管理 2改密码
      if (index == 0) {
        this.$router.push("./deliveryAddress");
      } else if (index == 1) {
        this.$router.push("./fabricLibrary");
      } else if (index == 2) {
        this.changePasswordShow = true;
      }
    },
  },
  mounted() {
    this.getAccountInfo();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-modal-close {
  display: none;
}
/deep/.ivu-modal-header {
  border: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
.password-box {
  height: 418px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 50px;
  }
  .input-box {
    height: 32px;
    width: 372px;
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    margin-bottom: 45px;
    div {
      width: 120px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 16px;
    }
    input {
      height: 20px;
      line-height: 20px;
      margin-left: 20px;
      border: none;
      outline: none;
    }
  }
}
.user {
  // width: 1440px;
  // margin: 0 auto;
  background: #fff;

  .user-msg-box {
    width: 100%;
    // background: #fff;
  }
  .user-msg {
    width: 1440px;
    margin: 0 auto;
    height: 154px;
    background: #fff;
    padding: 50px 50px 30px;
    position: relative;
    .log-out {
      width: 79px;
      height: 32px;
      line-height: 32px;
      opacity: 1;
      border: 1px solid #081938;
      border-radius: 5px;
      font-size: 14px;
      text-align: left;
      color: #081938;
      line-height: 30px;
      position: absolute;
      top: 30px;
      right: 50px;
      text-align: center;
    }
  }
  .header {
    width: 74px;
    height: 74px;
    margin-right: 25px;
  }
  .name {
    opacity: 1;
    font-size: 20px;
    font-weight: 600;
    text-align: left;
    color: #000000;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .user-function {
    // margin-top: 5px;
    width: 1440px;
    margin: 5px auto 0;
    > div {
      width: 477px;
      height: 177px;
      background: #f8f8f8;
      .title {
        font-size: 16px;
        font-weight: Condensed;
        text-align: center;
        color: #081938;
        line-height: 19px;
        margin-bottom: 14px;
      }
      .content {
        opacity: 0.7;
        font-size: 11px;
        font-weight: 400;
        text-align: center;
        color: #081938;
        line-height: 13px;
      }
    }
  }
  .type {
    font-size: 14px;
    font-weight: 300;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
    .iconzhanghao {
      border: 1px solid #0a4dcc;
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }
  }
  .user-date {
    width: 837px;
    margin-right: 129px;
    > div {
      width: 279px;
      height: 40px;
      .num {
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        line-height: 21px;
        margin-bottom: 10px;
      }
      .label {
        opacity: 0.4;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #081938;
        line-height: 16px;
      }
    }
  }
  .account-balance {
    font-size: 20px;
    font-weight: 500;
    color: #081938;
    line-height: 24px;
    margin: 30px 0 15px;
  }
  .account-tips {
    font-size: 12px;
    font-weight: 400;
    color: rgba(8, 25, 56, 0.7);
    line-height: 14px;
  }
  .recharge {
    width: 1440px;
    margin: 0 auto;
    height: 381px;
    background: #f8f8f8;
    position: relative;
    overflow: hidden;
    .bg-img {
      width: 535px;
      position: absolute;
      top: 123px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
    }
    .balance {
      width: 198px;
      height: 198px;
      background-image: url("../../assets/images/balance.png");
      background-size: 100% 100%;
      margin: 50px auto;
      position: relative;
      z-index: 9;
      font-size: 34px;
      font-family: Times, Times-Bold;
      font-weight: 700;
      text-align: center;
      color: #081938;
      line-height: 198px;
      .recharge-title {
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        line-height: 19px;
        position: absolute;
        font-family: Roboto;
        left: 0;
        right: 0;
        margin-right: auto;
        margin-left: auto;
        bottom: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/user.vue